<template>
  <div>
    <template v-if="!$store.state.navigation.site">
    <b-row class="row-welcome">
      <b-col cols="12" class>
        <div class="content welcome-block text-center pb-3 h-100">
          <h1 class="pt-25">
            ДОБРО ПОЖАЛОВАТЬ В
            <br />
            RADIUS-LAB
          </h1>
          <!-- <router-link  v-if="!auth_user" tag="b-button" to="/register" class="mt-4 btn-reg bg-color-first-header-item">ЗАРЕГИСТРИРОВАТЬСЯ</router-link> -->
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3 w-75 row row-block">
      <b-col cols="12">
        <div class="block-fixed" style="background-color:#002244">
          <div class="w-50">
            <img
              class="w-100"
              style="height: 300px"
              src="../images/main_page/block-fixed.jpg"
              alt=""
            />
          </div>
          <div class="m-auto what_is-block">
            <h3 class="text-uppercase" style="color:#29abe2">
              что такое radius-lab?
            </h3>
            <p style="color:white">
              RADIUS-LAB - это эксклюзивный программный
              <br />
              продукт, состоящий из полуавтономных
              <br />
              модулей, из которых, как из конструктора,
              <br />
              собирается необходимый индивидуальный
              <br />
              программный продукт, для продуктивной
              <br />
              работы вашего объекта.
            </p>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h1 class="text-uppercase text-center">Наши модули</h1>
        <div class="snake"></div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <div>
          <v-slider v-bind="options">
            <div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_basic.png"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right2">
                  <h4 class="mt-2 mb-2">Модуль "Базовый"</h4>
                  <p class="module-text">
                    &#10102; Панель Администратора
                    <br />
                    &#10103; Настройка пользователей,
                    <br />
                    ролей и прав доступа
                    <br />
                    &#10104; Настройка локализации
                    <br />
                    &#10105; Мониторинг действий пользователя
                    <br />
                    &#10106; Авторизация из других модулей происходит через
                    OAuth
                    <br />
                    &#10107; Аутентификация через ЕСИА
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div>
            <!--div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_bot.jpg"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right">
                  <h4 class="mt-2 mb-2">Модуль "Чат-бот"</h4>
                  <p class="module-text">
                    &#10102; Запись на прием через сайт или мобильное приложение
                    <br />
                    &#10103; Ответы на часто задаваемые вопросы
                    <br />
                    &#10104; Заявка на обратный звонок
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div-->
            <!--div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_cassa.jpg"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right">
                  <h4 class="mt-2 mb-2">Модуль "Касса"</h4>
                  <p class="module-text">
                    Модуль «Касса» облегчит работу на платные услуги Вашей
                    клиники.
                    <br />
                    &#10102; Формирование перечня услуг организаций
                    <br />
                    &#10103; Формирование гибкой системы тарифов
                    <br />
                    &#10104; Использование внешних справочников для формирования
                    услуг
                    <br />
                    &#10105; Учет оказанных услуг
                    <br />
                    &#10106; Оплата услуг через платежную систему
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div-->
            <div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_email.jpg"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right3">
                  <h4 class="">Модуль "Рассылка уведомлений"</h4>
                  <p class="module-text">
                    Модуль «Рассылка уведомлений» поможет Вам держать своих
                    пациентов в курсе всех новостей и акций клиники, а так же
                    напоминать пациентам о приеме и готовности анализов.
                    <br />
                    &#10102; Уведомление пациентов о событиях через email
                    <br />
                    &#10103; Уведомление пациентов о событиях через SMS
                    <br />
                    &#10104; Уведомление пользователей о событиях через
                    всплывающие сообщения на сайте
                    <br />
                    &#10105; Подписка на каналы рассылки уведомлений
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div>
            <!--div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_form.jpg"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right">
                  <h4 class="mt-2 mb-2">Модуль "Конструктор форм"</h4>
                  <p class="module-text">
                    Модуль «Конструктор форм» поможет Вам самим решать и
                    конструировать формы рецептов и бланков, необходимые для
                    корректной работы клиники.
                    <br />
                    &#10102; Создание произвольной формы
                    <br />
                    &#10103; Подключение формы к странице посредством
                    компонентов
                    <br />
                    &#10104; Поддержка версионности форм
                    <br />
                    &#10105; Сохранение данных формы в базу данных с последующим
                    редактированием
                    <br />
                    &#10106; Выведение сводной таблицы по данным формы
                    конкретной версии
                    <br />
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div-->
            <div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_online.jpg"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right">
                  <h4 class="mt-2 mb-2">Модуль "Online Консультаций"</h4>
                  <p class="module-text">
                    Модуль «Online консультаций» необходимый модуль для
                    Телеконференций
                    <br />
                    &#10102; Подача заявки на консультацию через направление
                    <br />
                    &#10103; Проведение консультации посредством
                    видеосвязи
                    <br />
                    &#10104; Электронная подпись документов
                    <br />
                    &#10105; Создание заключения по итогам консультации
                    <br />
                    &#10106; Поддержка любых форматов 
                    <br />
                    &#10107; Сохранение данных конференций
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div>
            <!--div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_pacient.jpg"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right">
                  <h4 class="mt-2 mb-2">Модуль "Прием пациента"</h4>
                  <p class="module-text">
                    Модуль «Прием пациента» облегчит
                    <br />
                    и снизит бумажную работу врачам.
                    <br />
                    &#10102; Просмотр электронной амбулаторной
                    <br />
                    карты пациента (форма 025/у)
                    <br />
                    &#10103; Формирование случаев обращений,
                    <br />
                    посещений и других услуг
                    <br />
                    &#10104; Формирование рецептов и врачебных заключений
                    <br />
                    &#10105; Формирование направлений на анализы и
                    госпитализацию
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div-->
            <!--div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_raspisanie.jpg"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right">
                  <h4 class="mt-2 mb-2">Модуль "Расписание"</h4>
                  <p class="module-text">
                    Модуль «Расписание» облегчит работу регистратуре. Вы сможете
                    сами создавать мероприятия и встречи в календаре
                    <br />
                    и отслеживать загруженность врачей.
                    <br />
                    &#10102; Формирование организаций, департаментов,
                    <br />
                    должностей, сотрудников
                    <br />
                    &#10103; Формирование нагрузки на должность и сотрудника
                    <br />
                    &#10104; Создание расписания сотрудника
                    <br />
                    на конкретном рабочем месте
                    <br />
                    &#10105; Назначение мероприятий на
                    <br />
                    рабочее место на конкретное
                    <br />
                    временное окно
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div-->
            <!--div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_record.jpg"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right">
                  <h4 class="mt-2 mb-2">Модуль "Запись на прием"</h4>
                  <p class="module-text">
                    Модуль «Запись на прием» облегчит и
                    <br />
                    снизит нагрузку на регистратуру.
                    <br />
                    &#10102; Формирование перечня доступных
                    <br />
                    сотрудников организации и
                    <br />
                    перечня временных окон,
                    <br />
                    доступных для записи
                    <br />
                    &#10103; Формирование электронной очереди
                    <br />
                    &#10104; Возможность записать на прием другое лицо
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div-->
            <div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_sprav.jpg"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right">
                  <h4 class="mt-2 mb-2">Модуль "Справочники"</h4>
                  <p class="module-text">
                    Больше не надо даваться в поиски,
                    <br />
                    ведь справочники всегда под рукой!
                    <br />
                    &#10102; Справочник МКБ 10
                    <br />
                    &#10103; Справочник РЛС
                    <br />
                    &#10104; Создание произвольного справочника
                    <br />
                    &#10105; Создание формы к справочнику
                    <br />
                    &#10106; Создание и сохранение версий справочника
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div>
            <!--div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_tfoms.jpeg"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right">
                  <h4 class="mt-2 mb-2">
                    Модуль "Выгрузка счетов на оплату ТФОМС"
                  </h4>
                  <p class="module-text">
                    &#10102; Проверка страховой принадлежности в реестре
                    застрахованных граждан
                    <br />
                    &#10103; Формирование реестра счетов на оплату
                    <br />
                    &#10104; Формирование файла реестра
                    <br />
                    установленного образца для
                    <br />
                    отправки в ТФОМС
                    <br />
                    &#10105; Чтение пришедшего файла ответа и
                    <br />
                    возможность внесения поступивших правок
                    <br />
                    &#10106; Хранения и версионирование формируемых счетов
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div-->
            <div class="item">
              <div class="container">
                <img
                  src="../images/main_page/module/module_video.jpg"
                  alt="Snow"
                  class="img-module"
                />
                <div class="top-right">
                  <h4 class="mt-2 mb-2">Модуль "Видеосвязь"</h4>
                  <p class="module-text">
                    Модуль «Видеосвязь» поможет сотрудникам вести Видеосвязь
                    на объекте.
                    <br />
                    &#10102; Создание бесед в видеочат-комнате
                    <br />
                    &#10103; Добавление в существующую беседу
                    <br />
                    &#10104; Просмотр списка доступных бесед
                    <br />
                    &#10105; Отправка текстовых сообщений
                    <br />
                    &#10106; Отправка файлов
                    <br />
                    &#10107; Видеоконференцсвязь
                    <br />
                    &#10108; Просмотр записанного видео по итоговой
                    видеоконференцсвязи
                  </p>
                  <b-button variant="info">Узнать больше</b-button>
                </div>
              </div>
            </div>
          </v-slider>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <div class="module-advantage">
          <div class="module-advantage-special">
            <div>
              <h1 class="text-uppercase mt-4 mb-4">В чем преимущество?</h1>
              <h4 class="text-uppercase">1) Интерфейс</h4>
              <p>
                Интуитивный, понятный интерфейс;
                <br />
                Удобство и простота использования
              </p>
              <h4 class="text-uppercase">2) Поддержка</h4>
              <p>
                Квалифицированная техническая
                <br />
                поддержка 24/7
              </p>
              <h4 class="text-uppercase">3) Нагрузка</h4>
              <p>
                Снижаем нагрузку работы
              </p>
              <h4 class="text-uppercase">4) Гибкость</h4>
              <p>
                Гибкость системы оплаты
              </p>
              <h4 class="text-uppercase">5) Обновление</h4>
              <p>
                Регулярное бесплатное обновление
              </p>
            </div>
            <div class="module-info-special-img">
              <img src="../images/main_page/module-info-special.jpg" alt="" />
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="m-0">
      <b-col class="p-0 pb-4" style="background-color: #002244;">
        <div class="video-block embed-responsive embed-responsive-16by9 m-auto">
          <iframe
            class="embed-responsive-item"
            src="https://www.youtube.com/embed/kgkYGKF1yo0"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </b-col>
    </b-row>
    </template>
    <template v-else>
      <custom-page />
    </template>
  </div>
</template>

<script>
import slider from '../plugins/vue-slider';
import CustomPage from './CustomSite/CustomPage.vue';
export default {
  components: {
    'v-slider': slider,
    CustomPage
  },
  data() {
    return {
      auth_user: this.$store.state.auth.is_auth,
      slide: 0,
      sliding: null,
      options: {
        items: 2,
        margin: 20,
        nav: true,
        dots: false,
        loop: true,
        timing: 'cubic-bezier(0, 0.72, 0.64, 1.06)',
        offset: 1,
        prevNav: '<',
        nextNav: '>',
        sibling: true,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          999: {
            items: 2
          }
        }
      }
    };
  },
  methods: {},
  mounted() {},
  computed: {
    //username: `${this.user.last_name} ${this.user.first_name} ${this.user.middle_name}`,
    getAuthUserFullName() {
      return this.$store.getters['auth/getAuthUserFullName'];
    }
  }
};
</script>

<style lang="sass" scoped>
.page-test
  overflow-x: hidden
.col
  padding: 0 !important
// Slider
.slider
    position: relative
    overflow: hidden
    max-width: 1600px
    margin: 0 auto
    padding-left: 40px
    padding-right: 40px

.slider__wrapper
    display: flex
    transition: transform 0.6s ease

.slider__item
    flex: 0 0 100%
    max-width: 100%
    padding-left: 10px
    padding-right: 10px

@media (min-width: 576px)
    .slider__item
        flex: 0 0 50%
        max-width: 50%

@media (min-width: 992px)
    .slider__item
        flex: 0 0 33.333333%
        max-width: 33.333333%

@media (min-width: 1200px)
    .slider__item
        flex: 0 0 25%
        max-width: 25%

.slider__control
    position: absolute
    top: 0
    display: flex
    align-items: center
    justify-content: center
    width: 50px
    color: #fff
    text-align: center
    bottom: 0
    background: #fff


.slider__control:hover,
.slider__control:focus
    color: #fff
    text-decoration: none
    outline: 0

.slider__control_left
    left: 0

.slider__control_right
    right: 0

.slider__control::before
    content: ''
    display: inline-block
    width: 20px
    height: 20px
    background: transparent no-repeat center center
    background-size: 100% 100%

.slider__control_left::before
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23424242' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E")

.slider__control_right::before
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23424242' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E")

.slider__content_header
    position: relative

.slider__content_img
    display: block
    height: auto
    max-width: 100%

.slider__content_section
    position: absolute
    bottom: 0
    left: 0
    background: #009688
    color: #fff
    padding: 4px 8px

.slider__content_title
    background: #f5f5f5
    color: #424242
    white-space: normal
    font-weight: 700
    font-size: 20px
    line-height: 1.3
    padding: 10px 15px
    margin: 0
    height: 52px


.slider__content_footer
    background: #f5f5f5
    display: flex
    padding: 20px 15px
    color: #616161

.slider__content_avatar
    flex: 0 0 40px
    max-width: 40px

.slider__content_photo
    display: block
    height: auto
    max-width: 100%
    border-radius: 50%

.slider__content_author
    margin-left: 8px
    line-height: 40px

.slider__content_icon
    height: 18px
    margin-top: 12px
    margin-left: auto
.slider__content_views
    margin-left: 4px
    line-height: 40px

        // End Slider
.box
    background-color: #257cb4
    height: 100%
    width: 50%

.video-block
    width: 90%
    height: 100%

.snake
    background-color: #45c0e8
    border-radius: 10px
    height: 20%
    margin: auto
    width: 50%

.img-module
    max-width: 100%
    height: 450px

.module-text
    text-align: left
    padding-left: 1rem
    font-size: 14px

.container
    position: relative
    text-align: center
    color: white
    width: 90%

.v_slider
    overflow: hidden
.top-right
    position: absolute
    top: 0
    right: 15px
    background-color: #212020
    width: 50%
    height: 100%
    text-align: center
    opacity: 0.9

.top-right2
    position: absolute
    top: 0
    right: 15px
    background-color: #212020
    width: 50%
    height: 100%
    text-align: center
    opacity: 0.9

.top-right3
    position: absolute
    top: 0
    right: 20px
    background-color: #212020
    width: 50%
    height: 100%
    text-align: center
    opacity: 0.9

.module-advantage
    background-color: rgb(0, 34, 68)
    padding-bottom: 0.5rem
    padding-top: 0.5rem

.module-advantage-special
    margin: 3rem
    background-color: white
    display: flex
    justify-content: space-around
    border-radius: 10px
    padding-bottom: 1rem

.module-info-special-img
    width: 50%

.module-info-special-img img
    width: 100%
    margin-top: 4rem

.block-fixed
    display: flex
    justify-content: space-space-evenly

.box-text
    color: white
    font-size: 16px
    font-weight: 500

.text_context
    width: 50%
    margin: auto

.row-block
    margin-top: -15rem
    margin-left: 10rem
    margin-right: 10rem

.box-middle
    background-color: #2ebae1
    height: 100%
    width: 50%
    margin: auto
.block-img
    width: 30%
    height: 100%
.list-mode
    list-style: none

.btn-reg
    border-radius: 20px
    padding: 0.5rem
    font-weight: 600

.color-first-header-item
     color: #29abe2

.row-welcome
     min-height: 800px

.color-link-info
     color: #041128 !important

.font-16
     font-size: 1.1em

.bg-color-first-header-item
    background-color: #50b5e0 !important
    color: white !important
    border-color: #29abe2 !important

.block-info-image
    display: flex
    justify-content: space-between

.welcome-block
    background: url("../images/main_page/back_welcome.jpg") 100% 100% no-repeat
    background-position: top
    background-size: cover
    background-color: rgba(0,0,0,.7)
    background-blend-mode: darken
    color: white

.block-text
    color: white
    font-family: "Roboto",sans-serif

.pt-25
    padding-top: 25rem

.item
  height: auto;
  background: none;

@media (max-width: 426px)
    .module-advantage-special
        padding: 10px

@media (max-width: 1366px)
    .module-advatage-special
        padding: 10px
@media (max-wdith: 1100px)
    .what_is-block
        padding: 5px
@media (max-width: 1366px)
    .module-advantage-special
        padding: 10px
@media (max-width: 1024px)
    .module-advantage-special
        margin: 0
        border-radius: 0
        padding-bottom: 0
        background-color: #002244
        color: white
        font-size: 14px
        padding: 10px
    .module-info-special-img img
        margin-top: 5rem
    .row-block
        display: none !important
    .top-right2
        right: auto
        width: 110%
    .top-right
        right: auto
        width: 110%
    .top-right3
        right: auto
        width: 110%
    .img-module
        max-width: 110%
    .container
        padding: 0
        margin: 0
@media (max-width: 640px)
    .container
        margin: 1rem !important
@media (max-width: 768px)
    .module-advantage-special
        margin: 0
        border-radius: 0
        padding-bottom: 0
        background-color: #002244
        color: white
        font-size: 14px
    .brand-nav
        display: none
    .module-info-special-img img
        display: none
    .row-block
        display: none !important
    .top-right2
        right: auto
        width: 110%
    .top-right
        right: auto
        width: 110%
    .top-right3
        right: auto
        width: 110%
    .img-module
        max-width: 110%
    .container
        padding: 0
        margin: 0
    // Media screens styles
@media (max-width: 400px) and (min-width: 374px)
    .welcome-block
        width: 100%
        height: 100%

@media (max-width: 575px) and (min-width: 440px)
    .can-block
        -webkit-box-flex: 0
        flex: 0 0 85%
        max-width: 100%
        margin-bottom: 1rem
    .about-module
        -webkit-box-flex: 0
        flex: 0 0 100%
        max-width: 100%
        margin-top: 0.5rem
    .box
        float: none !important
        width: 100%
    .box-middle
        width: 100%
    .last
        margin-left: 1rem
    .subs
        margin-right: 0.5rem
@media (max-width: 500px)
    .about-module
        -webkit-box-flex: 0
        flex: 0 0 100%
        max-width: 100%
        margin-top: 0.5rem
    .box
        float: none !important
        width: 100%
    .box-middle
        width: 100%
    .block-info-image
        img
            width: 30% !important
    .title-info
        font-size: 1.5rem
    .block-info-image
        margin-bottom: 1rem
    .last
        margin-left: 2rem
    .last-word
        width: 185px
    .img-first
        margin-left: 1rem
@media (min-width: 768px)
    .last
        margin-left: 0.5rem
    .last-word
        width: 190px

@media (max-width: 849px) and (min-width: 576px)
    .box
        width: 75%

    .box-middle
        width: 75%

    .row-welcome
        min-height: 200px

@media (min-width: 992px)
    .last-word
        width: 190px
@media (max-width: 1099px) and (min-width: 850px)
    .caption
        top: 70%
@media (min-width: 1200px)
    .last
        margin-left: 1rem
    .last-word
        width: 185px
@media (min-width: 1280px) and (max-width: 1366px)
    .top-right
        width: 51%

@media (max-width: 1300px) and (min-width: 1099px)
    .caption
        top: 75%
@media (max-width: 1440px) and (min-width: 1300px)
    .caption
        top: 80%
        padding-bottom: 10%

@media (max-width: 1632px) and (min-width: 1587px)
    .caption
        top: 85
    .col-xl-3
        flex: 0 0 20% !important
        max-width: 20% !important

@media (max-width: 1800px) and (min-width: 1632px)
    .caption
        top: 86%
    .col-xl-3
        flex: 0 0 20% !important
        max-width: 20% !important
    .last-word
        width: 185px
@media (max-width: 2000px) and (min-width: 1800px)
    .caption
        top: 90%
    .col-xl-3
        flex: 0 0 25% !important
        max-width: 30% !important
    .list-mode
        font-size: 1.5rem
    .title-info
        font-size: 1.5rem
    .last
        margin-left: 0
    .last-word
        width: 260px
@media (max-width: 2560px) and (min-width: 2000px)
    .caption
        top: 90%
    .col-xl-3
        flex: 0 0 20% !important
        max-width: 30% !important
    .list-mode
        font-size: 1.5rem
    .title-info
        font-size: 1.5rem
    .last
        margin-left: 0
    .last-word
        width: 260px
</style>
